export const messages = {
  en: {
    businessDatabus: {
      search: {
        title: 'Search Condition',
        databusName: 'databusName',
        businessTypeCd: 'businessTypeCd',
        beanName: 'beanName',
        seq: 'seq',
        state: 'state',
        createTime: 'createTime',
        placeholder: 'Please enter businessDatabus name'
      },
      list: {
        title: 'businessDatabus List'
      },
      dialog: {
        addTitle: 'Add BusinessDatabus',
        editTitle: 'Edit BusinessDatabus',
        delTitle: 'Delete BusinessDatabus',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        databusId: 'databusId',
        databusName: 'databusName',
        businessTypeCd: 'businessTypeCd',
        beanName: 'beanName',
        seq: 'seq',
        state: 'state',
        createTime: 'createTime',
      },
      table: {
        databusId: 'databusId',
        databusName: 'databusName',
        businessTypeCd: 'businessTypeCd',
        beanName: 'beanName',
        seq: 'seq',
        state: 'state',
        createTime: 'createTime',
      },
      validate: {
        databusId: 'Please enter databusId',
        databusName: 'Please enter databusName',
        businessTypeCd: 'Please enter businessTypeCd',
        beanName: 'Please enter beanName',
        seq: 'Please enter seq',
        state: 'Please enter state',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add BusinessDatabus success'
      },
      edit: {
        success: 'Edit BusinessDatabus success'
      },
      delete: {
        success: 'Delete BusinessDatabus success',
        confirm: 'Are you sure to delete this businessDatabus?'
      },
      fetchError: 'Failed to fetch businessDatabus list'
    }
  },
  zh: {
    businessDatabus: {
      search: {
        title: '查询条件',
        databusName: '名称',
        businessTypeCd: '业务类型',
        beanName: '适配器',
        seq: '顺序',
        state: '状态',
        createTime: '创建时间',
        placeholder: '请输入Databus名称'
      },
      list: {
        title: 'Databus'
      },
      dialog: {
        addTitle: '添加Databus',
        editTitle: '编辑Databus',
        delTitle: '删除Databus',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        databusId: '编号',
        databusName: '名称',
        businessTypeCd: '业务类型',
        beanName: '适配器',
        seq: '顺序',
        state: '状态',
        createTime: '创建时间',
      },
      table: {
        databusId: '编号',
        databusName: '名称',
        businessTypeCd: '业务类型',
        beanName: '适配器',
        seq: '顺序',
        state: '状态',
        createTime: '创建时间',
      },
      validate: {
        databusId: '请输入编号',
        databusName: '请输入名称',
        businessTypeCd: '请输入业务类型',
        beanName: '请输入适配器',
        seq: '请输入顺序',
        state: '状态',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加Databus成功'
      },
      edit: {
        success: '编辑Databus成功'
      },
      delete: {
        success: '删除Databus成功',
        confirm: '确认删除该Databus吗？'
      },
      fetchError: '获取Databus列表失败'
    }
  }
}